module.exports = __webpack_public_path__ + "img/ALLOSURVIE_Logo_FR.38ee18f1.svg";